export function getCurrentView(breakpoints) {
  /* 
    depending on window size, returns one of five values: "sml", "med", "lrg", "xlg", or "xxl"
    you can pass a custom JS object if you need custom breakpoints (optional):
    {
    "sml": custom value in px, or else defaults to 0px. optional
    "med": custom value in px, or else defaults to 433px. optional
    "lrg": custom value in px, or else defaults to 769px. optional
    "xlg": custom value in px, or else defaults to 1025px. optional
    "xxl": custom value in px, or else defaults to 1441px. optional
    }
*/
  const sml = breakpoints?.sml || '0px';
  const med = breakpoints?.med || '433px';
  const lrg = breakpoints?.lrg || '769px';
  const xlg = breakpoints?.xlg || '1025px';
  const xxl = breakpoints?.xxl || '1441px';
  let view;
  if (window.matchMedia(`(min-width: ${sml}) and (max-width: ${med})`).matches)
    view = 'sml';
  else if (
    window.matchMedia(`(min-width: ${med}) and (max-width: ${lrg})`).matches
  )
    view = 'med';
  else if (
    window.matchMedia(`(min-width: ${lrg}) and (max-width: ${xlg})`).matches
  )
    view = 'lrg';
  else if (
    window.matchMedia(`(min-width: ${xlg}) and (max-width: ${xxl})`).matches
  )
    view = 'xlg';
  else view = 'xxl';

  return view;
}

export function onViewChange(fn, breakpoint, query) {
  /* 
    runs a function when the specified media query is hit.
    accepts three arguments (all required):
        fn - the function that runs when the media query matches
        breakpoint - can be either default breakpoint values: "sml", "med", "lrg", "xlg", "xxl", or a custom value in px such as "100px"
        query - can be either "max" or "min", depending on if you want your query to fire at max-width: breakpoint or min-width: breakpoint
              - if query is left blank, function will fire every time breakpoint is hit on resize up or resize down
    */
  if (breakpoint == 'sml') breakpoint = '0px';
  else if (breakpoint == 'med') breakpoint = '433px';
  else if (breakpoint == 'lrg') breakpoint = '769px';
  else if (breakpoint == 'xlg') breakpoint = '1025px';
  else if (breakpoint == 'xxl') breakpoint = '1441px';

  if (query) {
    const mediaQuery = `(${query}-width:${breakpoint})`;
    const mediaQueryList = window.matchMedia(mediaQuery);
    mediaQueryList.addEventListener('change', (e) => {
      if (e.matches) fn();
    });
  } else {
    const mediaQueryMin = `(min-width:${breakpoint})`;
    const mediaQueryMax = `(max-width:${breakpoint})`;
    const mediaQueryMinList = window.matchMedia(mediaQueryMin);
    mediaQueryMinList.addEventListener('change', (e) => {
      if (e.matches) fn();
    });
    const mediaQueryMaxList = window.matchMedia(mediaQueryMax);
    mediaQueryMaxList.addEventListener('change', (e) => {
      if (e.matches) fn();
    });
  }
}

export function initCustomLinebreaks(text) {
  const breakpoints = ['xxl', 'xlg', 'lrg', 'med', 'sml'];
  const contentContainers = document.querySelectorAll('.content-container');
  contentContainers.forEach((container) => {
    breakpoints.forEach((breakpoint) => {
      text
        ? (text = text.replaceAll(
            `*br-${breakpoint}*`,
            `<br data-breakpoint='${breakpoint}'/>`
          ))
        : (container.innerHTML = container.innerHTML.replaceAll(
            `*br-${breakpoint}*`,
            `<br data-breakpoint='${breakpoint}'/>`
          ));
    });
    text
      ? (text = text.replaceAll('*br*', '<br/>'))
      : (container.innerHTML = container.innerHTML.replaceAll('*br*', '<br/>'));
  });

  return text
    ? text
    : new Promise((resolve) => {
        resolve('resolved');
      });
}
